import { CaseSubjectTypeFilterOptions } from "../../enums/filters-and-searchs/caseSubjectTypeFilterOptions"

export const CaseSubjectTypeFilterOptionsDetail = new Map<number, string>([
    [CaseSubjectTypeFilterOptions.None, 'None'],
    [CaseSubjectTypeFilterOptions.Deleted, 'Deleted Subject Types']
]);
